<template>
  <div id="app">
    <SEOMeta
      :title="$route.meta.seo?.title || $route.meta.title"
      :description="$route.meta.seo?.description"
      :keywords="$route.meta.seo?.keywords"
      :image="$route.meta.seo?.image"
      :structured-data="generateStructuredData()"
    />
    <Myheader v-if="!$route.meta.hideHeader"/>
    <router-view></router-view>
    <Myfoot v-if="!$route.meta.hideFooter"/>
    <!-- WhatsApp 暂时隐藏，已替换为 JivoSite -->
    <!-- <WhatsApp v-if="!$route.meta.hideWhatsApp"></WhatsApp> -->
  </div>
</template>

<script>
import Myheader from '@/components/myheader/myheader.vue'
import Myfoot from '@/components/myfoot/myfoot.vue'
// WhatsApp 暂时隐藏，已替换为 JivoSite
// import WhatsApp from '@/components/whatsapp/index.vue'
import SEOMeta from '@/components/SEOMeta'
import { canonicalPath, siteOrigin } from '@/utils/seoPolicy.mjs'
import { generateStructuredData } from '@/utils/seoConfig'

export default {
  name: 'App',
  data(){
    return {
    }
  },
  components: {
    Myheader,
    Myfoot,
    SEOMeta,
    // WhatsApp
  },
  methods: {
    generateStructuredData() {
      return generateStructuredData(this.$route.name, {
        title: this.$route.meta.seo?.title || this.$route.meta.title,
        description: this.$route.meta.seo?.description,
        url: siteOrigin(process.env.VUE_APP_SITE_URL || 'https://www.kamsled.com') + canonicalPath(this.$route),
        image: this.$route.meta.seo?.image
      })
    }
  },
  created(){
    const userAgent = window.navigator.userAgent;
    if (/Mobile|Android|iPhone|iPod|iPad|Windows Phone/i.test(userAgent)) {
        window.localStorage.setItem('isH5',true)
      }else if(document.body.clientWidth<=1024){
      window.localStorage.setItem('isH5',true)
    }else if(document.body.clientWidth>1024){
      window.localStorage.setItem('isH5',false)
    }
       else {
        window.localStorage.setItem('isH5',false)
    }
  }
}
</script>

<style >
*{
  font-family: 'Manrope-Regular',sans-serif;
}
#app {
  font-family: 'Manrope-Regular',sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #999;
  overflow-x: hidden;
  max-width: 100vw;

}
p{
  cursor: default;
}

/* 滚动条整体样式 */
::-webkit-scrollbar {
    width: 12px;  /* 滚动条宽度 */
    height: 12px; /* 垂直滚动条高度 */
}
 
/* 滚动条轨道 */
::-webkit-scrollbar-track {
    background: #f1f1f1; /* 轨道颜色 */
    border-radius: 10px; /* 圆角 */
}
 
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background: #888; /* 滑块颜色 */
    border-radius: 10px; /* 圆角 */
    border: 5px solid #f1f1f1; /* 滑块边缘颜色，与轨道颜色相同，形成视觉上的内边距 */
}
 
/* 滑块在悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
    background: #555; /* 悬停时滑块颜色 */
}
@media screen and (max-width: 2560px){
    html {
      font-size: 16px;
    }
    
    
}
@media screen and (max-width: 1920px){
    html {
      font-size: 12px;
    }
}
@media screen and (max-width: 1440px){
    html {
      font-size: 10px;
    }
}
@media screen and (max-width: 1024px){
    html {
      font-size: 8px;
    }
    .el-message-box {
      width: 90vw !important;
    }
    .el-message-box__wrapper{
      top: 10vh !important;
    }
}
@media screen and (max-width:768px){
    html {
      font-size: 6px;
    }
}
@media screen and (max-width: 640px){
    html {
      font-size: 4px;
    }
}
@media screen and (max-width: 480px){
    html {
      font-size: 3px;
    }
}
@media screen and (max-width: 320px){
    html {
      font-size: 2px;
    }
}
.el-breadcrumb__inner a:hover, .el-breadcrumb__inner.is-link:hover {
  color: #D71518 !important;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner, .el-breadcrumb__item:last-child .el-breadcrumb__inner a, .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover, .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover{
  cursor: default !important;
}
.messageBox {
  z-index: 10001 !important; /* 根据需要调整这个值 */
}
a{
  text-decoration: none;
  color: black;
  cursor: pointer;
}
</style>
